import Box from '@zenbusiness/zui/Box';
import Stack from '@zenbusiness/zui/Stack';
import PropTypes from 'prop-types';

import {
  ContainerGridStyled,
  DialogActionsStyled,
  FirstButtonWrapper,
  SecondButtonWrapper
} from '#client/components/Grid/ActionButtonsGrid.style';
import { FocusGrid } from '#client/components/Grid/FocusGrid.style';
import useBreakpoints from '#client/hooks/useBreakpoints';

import { ButtonWrapper } from './ButtonWrapper';

import { ACTION_BUTTON_TYPE } from './constants';

const ActionTwoButtonsGrid = ({ firstButton, secondButton, type }) => {
  const {
    sizes: { isDesktop }
  } = useBreakpoints();

  const listBtn = (
    <Stack
      direction="row"
      gap="8px"
    >
      <Box>{firstButton}</Box>
      <Box>{secondButton}</Box>
    </Stack>
  );

  return (
    <DialogActionsStyled>
      <ContainerGridStyled>
        <FocusGrid>
          {isDesktop ? (
            <ButtonWrapper type={type}>{listBtn}</ButtonWrapper>
          ) : (
            <>
              <FirstButtonWrapper>{secondButton}</FirstButtonWrapper>
              <SecondButtonWrapper>{firstButton}</SecondButtonWrapper>
            </>
          )}
        </FocusGrid>
      </ContainerGridStyled>
    </DialogActionsStyled>
  );
};

ActionTwoButtonsGrid.propTypes = {
  firstButton: PropTypes.node.isRequired,
  secondButton: PropTypes.node.isRequired,
  type: PropTypes.oneOf([...Object.values(ACTION_BUTTON_TYPE)])
};

export default ActionTwoButtonsGrid;
